const cv = window.cv;

export class MultiPoseUtility {
  static LEFT_ANKLE_IDX_MP = 15;
  static RIGHT_ANKLE_IDX_MP = 16;

  static persons_detected(poses) {
    if (!poses || poses.length === 0) {
      return false;
    }
    return poses.some((element) => element.score > 0.25);
  }

  static is_everyone_behind_the_point(poses, point, calibration) {
    if (!MultiPoseUtility.persons_detected(poses)) {
      return false;
    }

    for (let person of poses) {
      if (person.score > 0.25) {
        let left_ankle = person.keypoints[this.LEFT_ANKLE_IDX_MP];
        let right_ankle = person.keypoints[this.RIGHT_ANKLE_IDX_MP];
        let warped_left_ankle =
          calibration.get_birds_eye_view_point(left_ankle);
        let warped_right_ankle =
          calibration.get_birds_eye_view_point(right_ankle);

        if (
          // warped_left_ankle.y < 0 ||
          // warped_right_ankle.y < 0 ||
          warped_left_ankle.y > point.y ||
          warped_right_ankle.y > point.y
        ) {
          return false;
        }
      }
    }
    return true;
  }

  static are_both_ankles_in_box(
    poses,
    patient_feet_box_x,
    patient_feet_box_y,
    camera
  ) {
    if (!MultiPoseUtility.persons_detected(poses)) {
      return false;
    }

    for (let person of poses) {
      if (person.score > 0.25) {
        let left_ankle = person.keypoints[this.LEFT_ANKLE_IDX_MP];
        let right_ankle = person.keypoints[this.RIGHT_ANKLE_IDX_MP];
        let left_ankle_x = camera.scale_to_fit({
          x: left_ankle.x,
          y: 0,
        }).x;
        let right_ankle_x = camera.scale_to_fit({
          x: right_ankle.x,
          y: 0,
        }).x;

        if (
          left_ankle_x > patient_feet_box_x[0] &&
          left_ankle_x < patient_feet_box_x[1] &&
          left_ankle.y > patient_feet_box_y[0] &&
          left_ankle.y < patient_feet_box_y[1] &&
          right_ankle_x > patient_feet_box_x[0] &&
          right_ankle_x < patient_feet_box_x[1] &&
          right_ankle.y > patient_feet_box_y[0] &&
          right_ankle.y < patient_feet_box_y[1]
        ) {
          return true;
        }
      }
    }
    return false;
  }

  static are_both_ankles_in_canvas_box(
    poses,
    bounding_box,
    camera,
    innerBufferPercent = 0
  ) {
    if (!MultiPoseUtility.persons_detected(poses)) {
      return false;
    }

    let inner_buffer = Math.abs(bounding_box.height * innerBufferPercent);

    for (let person of poses) {
      if (person.score > 0.25) {
        let left_ankle = camera.scale_to_fit({
          x: person.keypoints[this.LEFT_ANKLE_IDX_MP].x,
          y: person.keypoints[this.LEFT_ANKLE_IDX_MP].y,
        });
        let right_ankle = camera.scale_to_fit({
          x: person.keypoints[this.RIGHT_ANKLE_IDX_MP].x,
          y: person.keypoints[this.RIGHT_ANKLE_IDX_MP].y,
        });

        if (
          left_ankle.x > bounding_box.x &&
          left_ankle.x < bounding_box.x + bounding_box.width &&
          left_ankle.y > bounding_box.y + inner_buffer &&
          left_ankle.y < bounding_box.y + bounding_box.height - inner_buffer &&
          right_ankle.x > bounding_box.x &&
          right_ankle.x < bounding_box.x + bounding_box.width &&
          right_ankle.y > bounding_box.y + inner_buffer &&
          right_ankle.y < bounding_box.y + bounding_box.height - inner_buffer
        ) {
          return true;
        }
      }
    }
    return false;
  }

  static is_someone_in_box(
    poses,
    patient_feet_box_x,
    patient_feet_box_y,
    camera
  ) {
    if (!MultiPoseUtility.persons_detected(poses)) {
      return false;
    }

    for (let person of poses) {
      if (person.score > 0.25) {
        let left_ankle = person.keypoints[this.LEFT_ANKLE_IDX_MP];
        let right_ankle = person.keypoints[this.RIGHT_ANKLE_IDX_MP];
        let left_ankle_x = camera.scale_to_fit({
          x: left_ankle.x,
          y: 0,
        }).x;
        let right_ankle_x = camera.scale_to_fit({
          x: right_ankle.x,
          y: 0,
        }).x;

        if (
          right_ankle_x > patient_feet_box_x[0] &&
          left_ankle_x < patient_feet_box_x[1] &&
          right_ankle.y > patient_feet_box_y[0] &&
          left_ankle.y < patient_feet_box_y[1]
        ) {
          return true;
        }
      }
    }
    return false;
  }

  static get_poses_in_box(
    poses,
    patient_feet_box_x,
    patient_feet_box_y,
    camera
  ) {
    if (!poses || poses.length === 0) return [];
    const inside = [];
    for (let person of poses) {
      if (person && person.score > 0.25) {
        const left_ankle = person.keypoints[this.LEFT_ANKLE_IDX_MP];
        const right_ankle = person.keypoints[this.RIGHT_ANKLE_IDX_MP];
        if (!left_ankle || !right_ankle) continue;

        const left_ankle_x = camera.scale_to_fit({ x: left_ankle.x, y: 0 }).x;
        const right_ankle_x = camera.scale_to_fit({ x: right_ankle.x, y: 0 }).x;

        if (
          right_ankle_x > patient_feet_box_x[0] &&
          left_ankle_x < patient_feet_box_x[1] &&
          right_ankle.y > patient_feet_box_y[0] &&
          left_ankle.y < patient_feet_box_y[1]
        ) {
          inside.push(person);
        }
      }
    }
    return inside;
  }
  static return_patient(
    poses,
    patient_feet_box_x,
    patient_feet_box_y,
    therapist_id,
    camera
  ) {
    if (!MultiPoseUtility.persons_detected(poses)) {
      return false;
    }
    let patient_ID = null;
    let min_feet_to_center_distance = 10000;
    let therapist_pose = null;

    for (let person of poses) {
      if (person.id === therapist_id) {
        therapist_pose = person;
      }
      if (person.score > 0.25 && person.id !== therapist_id) {
        let left_ankle = person.keypoints[this.LEFT_ANKLE_IDX_MP];
        let right_ankle = person.keypoints[this.RIGHT_ANKLE_IDX_MP];
        let left_ankle_x = camera.scale_to_fit({
          x: left_ankle.x,
          y: 0,
        }).x;
        let right_ankle_x = camera.scale_to_fit({
          x: right_ankle.x,
          y: 0,
        }).x;

        // This check will make sure that feet are within the feet-box
        if (
          right_ankle_x > patient_feet_box_x[0] &&
          left_ankle_x < patient_feet_box_x[1] &&
          left_ankle.y > patient_feet_box_y[0] &&
          right_ankle.y < patient_feet_box_y[1]
        ) {
          // If we have multiple people in the box. then One closest to the centre will be chosen
          let current_feet_to_center_distance = Math.abs(
            (left_ankle_x + right_ankle_x) / 2 -
              (patient_feet_box_x[0] + patient_feet_box_x[1]) / 2
          );

          if (current_feet_to_center_distance < min_feet_to_center_distance) {
            min_feet_to_center_distance = current_feet_to_center_distance;
            patient_ID = person;
          }
        }
      }
    }
    if (patient_ID) {
      return patient_ID;
    }
    let left_ankle = therapist_pose.keypoints[this.LEFT_ANKLE_IDX_MP];
    let right_ankle = therapist_pose.keypoints[this.RIGHT_ANKLE_IDX_MP];
    let left_ankle_x = camera.scale_to_fit({
      x: left_ankle.x,
      y: 0,
    }).x;
    let right_ankle_x = camera.scale_to_fit({
      x: right_ankle.x,
      y: 0,
    }).x;

    if (
      right_ankle_x > patient_feet_box_x[0] &&
      left_ankle_x < patient_feet_box_x[1] &&
      left_ankle.y > patient_feet_box_y[0] &&
      right_ankle.y < patient_feet_box_y[1]
    ) {
      return therapist_pose;
    }
    return null;
  }
}
